/**
 * localStorage事件
 * @desc 用于监听localStorage的变动，从而实现跨窗口通信
 */
export enum LS_EVENT {
    /**
     * 刷新页面
     */
    REFRESH_PAGE = 'refresh_page',
    /**
     * 会员中心消息广播手动关闭时间
     */
    MESSAGE_BROADCAST_TIME = 'message_broadcast_time',
}

/** 记录会员中心消息广播关闭时间 */
export function setMessageBroadcastTime (time: string) {
    localStorage.setItem(LS_EVENT.MESSAGE_BROADCAST_TIME, time)
}

/** 获取会员中心消息广播关闭时间 */
export function getMessageBroadcastTime () {
    return Number(localStorage.getItem(LS_EVENT.MESSAGE_BROADCAST_TIME))
}
